import React from "react"
import { Box } from "@mui/material"
import { AppValueChip } from "@components"


export default function acrissColumn() {
	return {
		name: "acriss", label: "Acriss",
		options: {
			sort: false,
			headerAlign: 'center',
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 0.5 }}>
				{[...(value ?? [])].sort((a, b) => a.localeCompare(b)).map((item, idx) => (
					<AppValueChip key={idx} tone="accent">{item}</AppValueChip>
				))}
			</Box>,
		}
	}
}
